import * as React from 'react';
import { SVGProps } from 'react';

const SvgTabChip = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 6v12l6-6-6-6z" />
  </svg>
);

export default SvgTabChip;
